import styled from 'styled-components';
import { vw } from 'components/common/Common';
import { P, Link } from '../Jet.style';
import Arrow from '../../../assets/imgs/webp/arrow_hover.webp';

const JetHeader = styled.div`
  width: 100%;
  height: ${(props) => vw(props.$height)};
  background-image: url(${(props) => props.$imgUrl});
  background-size: cover;
  background-position: center;
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: ${(props) => (props.$isRight ? 'flex-end' : 'flex-start')};
  flex-direction: column;
  text-align: left;
  padding: 0 ${vw(100)} ${vw(60)};
  background-color: rgba(5, 10, 48, 0.6);
  gap: ${vw(30)};
  a {
    align-self: flex-end;
    border: none;
    :hover {
      color: #fff;
      ::after {
        background-position: ${vw(-84)} ${vw(-20)};
      }
    }

    ::after {
      content: '';
      display: inline-block;
      width: ${vw(40)};
      height: ${vw(40)};
      background-repeat: no-repeat;
      background-image: url(${Arrow});
      background-size: ${vw(144)} ${vw(80)};
      background-position: ${vw(-20)} ${vw(-20)};
      vertical-align: middle;
      margin-left: ${vw(24)};
    }
  }
`;

const Header = ({ urlText, url, imgUrl, titleContent, descContent, height, isRight }) => {
  return (
    <JetHeader $imgUrl={imgUrl} $height={height}>
      <Content $isRight={isRight}>
        {titleContent}
        {descContent}
        <Link href={url} $borderColor="#fff" $color="#fff" $weight="600">
          {urlText}
        </Link>
      </Content>
    </JetHeader>
  );
};

export default Header;
